import script from "./form-search-strategy.vue?vue&type=script&setup=true&lang=js"
export * from "./form-search-strategy.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__